import { call } from './call';

export const createCardToken = (number, expiryMonth, expiryYear, cvc, nameOnCard, lastName) => {
  const params = {
    CreditCardNumber: number,
    CreditCardExpiryMonth: expiryMonth,
    CreditCardExpiryYear: expiryYear,
    CreditCardCCV: cvc,
    NameOnCreditCard: nameOnCard,
    LastName: lastName,
  };

  return call(params);
};



// WEBPACK FOOTER //
// ./lib/ezidebit/createCardToken.ts